import type { CSSProperties } from "react";

import { cn } from "../../lib/utils.js";
import { festiveWhen, type ActiveFestival } from "../../lib/festive/getActiveFestival.js";
import { useFestiveReducedMotion } from "../../hooks/useActiveFestival.js";
import { festiveIcon, isCompanyIcon } from "./festive-icons.js";

/**
 * A small dark pill: the festival icon, the greeting, a divider and the countdown, for example
 * "Happy Diwali | 5 days to go". It is always drawn on dark, so it reads the same on the light and
 * dark pages. The accent colours its border and countdown. The accent reaches CSS through a custom
 * property on this root (see .fi-chip in tokens.css), because a static class cannot hold it.
 */
export function FestiveChip({ active, className }: { active: ActiveFestival; className?: string }) {
  const reduce = useFestiveReducedMotion();
  const { icon, accent, wish } = active.festival;
  return (
    <span
      className={cn("fi-chip", className)}
      data-reduce={reduce ? "true" : "false"}
      style={{ "--fi-accent": accent } as CSSProperties}
    >
      <span className={cn("fi-chip-icon", isCompanyIcon(icon) && "fi-company")}>{festiveIcon(icon)}</span>
      <span className="fi-chip-wish">{wish}</span>
      <span className="fi-chip-rule" aria-hidden="true" />
      <span className="fi-chip-count">{festiveWhen(active)}</span>
    </span>
  );
}
